module.exports = __webpack_public_path__ + "static/media/info.c60d9ce9.svg";